import ReactGA from "react-ga4";

// ─── Init ──────────────────────────────────────────────────────────────────────
// Called once in index.js. Replace G-XXXXXXXXXX with your GA4 Measurement ID.
// Get it from: Google Analytics → Admin → Data Streams → your stream → Measurement ID

export const initGA = () => {
  ReactGA.initialize(
    process.env.REACT_APP_GA_MEASUREMENT_ID || "G-XXXXXXXXXX",
    {
      // Set to true to see events logged in the browser console during development
      testMode: process.env.NODE_ENV !== "production",
    },
  );
};

// ─── Page view ─────────────────────────────────────────────────────────────────
// Called automatically by usePageTracking() in App.js on every route change.

export const trackPageView = (path, title) => {
  ReactGA.send({ hitType: "pageview", page: path, title });
};

// ─── Generic event helper ──────────────────────────────────────────────────────

export const trackEvent = (category, action, label, value) => {
  ReactGA.event({ category, action, label, value });
};

// ─── Preorder page events ──────────────────────────────────────────────────────

export const trackPreorderPageView = () =>
  trackEvent("Preorder", "page_view", "Preorder page opened");

export const trackSizeSelected = (size) =>
  trackEvent("Preorder", "size_selected", size);

export const trackSliderNav = (direction, slideIndex) =>
  trackEvent("Preorder", "slider_navigation", direction, slideIndex);

export const trackPreorderFormStart = () =>
  trackEvent("Preorder", "form_start", "User started filling preorder form");

export const trackPreorderSubmit = (size) =>
  trackEvent("Preorder", "form_submit", `Size: ${size}`);

export const trackPreorderSuccess = (size) =>
  trackEvent("Preorder", "purchase_intent", `Size: ${size}`);

export const trackPreorderError = (reason) =>
  trackEvent("Preorder", "form_error", reason);

export const trackStripeRedirect = (size) =>
  trackEvent("Preorder", "stripe_redirect", `Size: ${size}`);

// ─── Waitlist events ───────────────────────────────────────────────────────────

export const trackWaitlistPageView = () =>
  trackEvent("Waitlist", "page_view", "Waitlist page opened");

export const trackWaitlistFormStart = () =>
  trackEvent("Waitlist", "form_start", "User started filling waitlist form");

export const trackWaitlistSubmit = (state) =>
  trackEvent("Waitlist", "form_submit", `State: ${state}`);

export const trackWaitlistSuccess = () =>
  trackEvent("Waitlist", "signup_success", "Waitlist signup completed");

export const trackWaitlistError = (reason) =>
  trackEvent("Waitlist", "form_error", reason);

// ─── Navigation events ─────────────────────────────────────────────────────────

export const trackNavClick = (destination) =>
  trackEvent("Navigation", "click", destination);

export const trackBackBtn = (from) =>
  trackEvent("Navigation", "back_button", from);

// ─── Home page events ──────────────────────────────────────────────────────────

export const trackCTAClick = (ctaLabel, section) =>
  trackEvent("CTA", "click", `${ctaLabel} — ${section}`);

export const trackVideoPlay = (videoName) =>
  trackEvent("Engagement", "video_play", videoName);

export const trackFAQOpen = (question) =>
  trackEvent("Engagement", "faq_open", question);

export const trackContactSubmit = () =>
  trackEvent("Contact", "form_submit", "Contact form submitted");

// ─── T-shirt teaser page ───────────────────────────────────────────────────────

export const trackTshirtPageView = () =>
  trackEvent("TShirt", "page_view", "Shirt teaser page opened");

export const trackTshirtCTAClick = () =>
  trackEvent("TShirt", "cta_click", "Shirt CTA clicked");

// ─── Engagement ────────────────────────────────────────────────────────────────

export const trackScrollDepth = (percent, page) =>
  trackEvent("Engagement", "scroll_depth", page, percent);

export const trackExternalLink = (url) =>
  trackEvent("Engagement", "external_link_click", url);
